module.exports = __webpack_public_path__ + "img/8.7442de75.jpg";